import { checkForAccess } from 'rp-navigation';
import browserHistory from '../index';

const showBarrier = (
    event,
    url,
    tabNameText = '',
    shouldUseCustomMetering = false,
    userRole,
    pageName,
) => {
    event.preventDefault();

    let isFreeTrial = sessionStorage.getItem('isFreeTrial') === 'true';

    if (pageName === 'horse_profile' && tabNameText !== 'Entries') {
        // If the page is horse_profile but not Entries tab, there shouldn't be a free trial - JP-9931
        // this includes the stallion book
        isFreeTrial = false;
        sessionStorage.setItem('isFreeTrial', 'false');
    } else {
        // If the page is not on horse_profile (trainer_profile) or is Entries tab on horse_profile, show free trial as it is in the header - JP-9931
        isFreeTrial = sessionStorage.getItem('freeTrialHeader');
        sessionStorage.setItem('isFreeTrial', sessionStorage.getItem('freeTrialHeader'));
    }

    const urlToRedirect = `${window.location.origin}/profile/${url.split('#')[0]}`;
    const lightBoxText = isFreeTrial ? 'Sign up for free to access this feature' :
        'Subscribe to Racing Post+ and get access to this content and much more';

    localStorage.setItem('subsection', tabNameText);

    if (shouldUseCustomMetering) {
        const hasAccess = checkForAccess('Subscriptions', true, true,
            {
                text: lightBoxText,
                r: urlToRedirect,
                service: 'both',
            },
        true,
        userRole,
        pageName,
        tabNameText.toLowerCase().replace(/\s/g, '_') // this is section argument
    );

        if (hasAccess) {
            browserHistory.push(url);
        }
    } else {
        checkForAccess('Subscriptions', true, true,
            {
                text: lightBoxText,
                r: urlToRedirect,
                service: 'both',
            }).then((hasAccess) => {
                if (hasAccess) {
                    browserHistory.push(url);
                }
            });
    }
};

export default showBarrier;



// WEBPACK FOOTER //
// ./src/js/utils/showBarrier.js